import { sessionApi } from '@texas/api/endpoints/sessionApi';
import { ServerStatePoll } from '@texas/messageBus/messages';
import { usePublisher } from '@texas/messageBus/useMessageBus';
import { createContextValue } from '@texas/utils/contextState';
import { useCallback, useEffect } from 'react';

const interval = 10000;

export function useJobRecordsStore() {
  const { publish } = usePublisher();

  const fetchAndPublish = useCallback(async () => {
    const response = await sessionApi.getServerState();
    if (!response.hasError) {
      publish(new ServerStatePoll(response.data));
    }
  }, [publish]);

  useEffect(() => {
    let isActive = true;

    const run = async () => {
      if (!isActive) return;
      await fetchAndPublish();
    };

    run();
    const id = setInterval(() => {
      run();
    }, interval);

    return () => {
      isActive = false;
      clearInterval(id);
    };
  }, [fetchAndPublish]);
}

export const [JobRecordsStoreProvider, useJobRecordsStoreProvider] =
  createContextValue<ReturnType<typeof useJobRecordsStore>>();
